const flattenHierarchy = (hierarchy, folderLevel = 0) => {
  const flattened = [];

  hierarchy.forEach((task) => {
    task.folderLevel = folderLevel;
    flattened.push(task);

    if (task.children && task.children.length) {
      const children = flattenHierarchy(task.children, folderLevel + 1);
      flattened.push(...children);
    }
  });

  return flattened;
};

const sortQuestionsHierarchy = (questions) => {
  const questionMap = new Map();
  let hierarchy = [];
  questions.sort((a, b) => {
    if (a.parentId && !b.parentId) {
      return 1;
    }
    if (!a.parentId && b.parentId) {
      return -1;
    }
    return a.label - b.label;
  });

  questions.forEach((question) => {
    question.children = [];
    questionMap.set(question._id, question);
  });

  questions.forEach((question) => {
    if (question.parentId) {
      const parentTask = questionMap.get(question.parentId);
      if (parentTask) {
        parentTask.children.push(question);
      }
    } else {
      hierarchy.push(question);
    }
  });

  if (hierarchy.length === 0 && questions.length > 0) {
    hierarchy = questions;
  } else {
    // Sort children by subLabel recursively
    const sortChildren = (items) => {
      items.forEach((item) => {
        if (item.children && item.children.length > 0) {
          item.children.sort((a, b) => a.subLabel - b.subLabel);
          sortChildren(item.children);
        }
      });
    };
    sortChildren(hierarchy);
  }
  return flattenHierarchy(hierarchy);
};

module.exports = sortQuestionsHierarchy;
